import { render, staticRenderFns } from "./tree-edit.vue?vue&type=template&id=e7019c08&scoped=true"
import script from "./tree-edit.vue?vue&type=script&lang=js"
export * from "./tree-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7019c08",
  null
  
)

export default component.exports